@let line = lineInput();
<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Unit Information - {{ line.description }}</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput">
          <button class="inputButton" matButton="elevated" (click)="showTagsDialog()" [class.invalidTags]="invalidTags()">
            <span class="buttonLabel">Tags</span>
          </button>
          @if (invalidTags()) {
            <span class="invalidTagMessage">Please correct the tags for this unit</span>
          }
        </span>
        <div class="halfWidthConfigurationInput">
          <span class="inputLabel">Quantity:</span>
          <input (change)="updateQuantity()" type="number" class="inputTextField" [(ngModel)]="line.quantityExtended" />
          @if (packagingSelection) {
            <span>
              <span class="inputLabel">Packaging:</span>
              <select
                class="inputSelectField"
                #packagingInput
                [class.invalidConfigurationSelection]="isInvalidSelection(packagingSelection.Name)"
                (change)="selectionChanged(packagingSelection, packagingInput.value)"
                [value]="packagingSelection.Value.toString()">
                @for (allowable of packagingSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="packagingSelection.Value && packagingSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          }
        </div>
      </div>
      @if (shippingSelection) {
        <div class="configurationDetailRow">
          <div class="halfWidthConfigurationInput"></div>
          <span>
            <span class="inputLabel">Shipping:</span>
            <select
              class="inputSelectField"
              #shippingInput
              [class.invalidConfigurationSelection]="isInvalidSelection(shippingSelection.Name)"
              (change)="selectionChanged(shippingSelection, shippingInput.value)"
              [value]="shippingSelection.Value.toString()">
              @for (allowable of shippingSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="shippingSelection.Value && shippingSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        </div>
      }
      <div class="configurationDetailRow">
        @if (isOem()) {
          <span>
            <span class="halfWidthConfigurationInput">
              <span class="halfWidthInputLabel">Customer Item ID:</span>
              <input class="halfWidthInputField" [(ngModel)]="line.customerItemId" />
            </span>
            <span class="halfWidthConfigurationInput">
              <span class="halfWidthInputLabel">PO Amount:</span>
              <input class="halfWidthInputField" [(ngModel)]="line.numericUserField3" />
            </span>
          </span>
        }
      </div>
    </div>
  }
</div>
